/* esm.sh - es-toolkit@1.52.0/dist/predicate/isBuffer */
import{globalThis_ as f}from"es-toolkit/dist/_internal/globalThis";function u(e){return typeof f.Buffer<"u"&&f.Buffer.isBuffer(e)}export{u as isBuffer};
//# sourceMappingURL=isBuffer.mjs.map